export default "__VITE_ASSET__DshTGmo2__"